import api from './axios';

export const getNotifications = async (type = '') => {
  const response = await api.get('/notifications', { params: { type } });
  return response.data;
};

export const getUnreadCount = async () => {
  const response = await api.get('/notifications/count');
  return response.data;
};

export const markAsRead = async (id) => {
  const response = await api.post(`/notifications/${id}/mark-read`);
  return response.data;
};

export const markAllAsRead = async () => {
  const response = await api.post('/notifications/mark-all-read');
  return response.data;
};

export const deleteNotification = async (id) => {
  await api.delete(`/notifications/${id}`);
};

export const clearAllNotifications = async () => {
  const response = await api.delete('/notifications/clear/all');
  return response.data;
};
